"use client";

import { RefObject } from "react";

import { Search } from "@/components/search/search.component";
import { Select } from "@/components/select/select.component";
import { SelectOption } from "@/components/select/selectOption.component";

import { ProductAccessoriesActionState } from "@/app/blu/shop/actions";
import {
  PDP_FORM_ACCESSORIES_SORT,
  PDP_FORM_SEARCH,
  SORT_OPTIONS,
} from "@/app/blu/shop/constants";
import { GetKitPageAccessoriesQueryResult } from "@/sanity.types";

export const ConfiguratorAccessoriesFilter = ({
  formRef,
  response,
  pending,
}: ConfiguratorAccessoriesFilterProps) => {
  return (
    <section
      data-testid="configurator-accessories-filter"
      className="flex justify-between gap-4">
      <div className="flex lg:flex-1">
        <div className="w-full min-w-0 md:w-fit">
          <Select
            data-testid="configurator-accessories-filter-sort"
            id={PDP_FORM_ACCESSORIES_SORT}
            name={PDP_FORM_ACCESSORIES_SORT}
            defaultValue={response?.sort}
            onChange={() => formRef.current?.requestSubmit()}
            loading={pending}>
            {SORT_OPTIONS.map(({ value, label }) => (
              <SelectOption key={value} value={value}>
                {label}
              </SelectOption>
            ))}
          </Select>
        </div>
      </div>
      <Search
        data-testid="configurator-accessories-filter-search-input"
        id={PDP_FORM_SEARCH}
        name={PDP_FORM_SEARCH}
        placeholder="Search"
        defaultValue={response?.search}
        debounce
        onChange={() => formRef.current?.requestSubmit()}
        onReset={() => formRef.current?.requestSubmit()}
      />
    </section>
  );
};

export type ConfiguratorAccessoriesFilterProps = {
  formRef: RefObject<HTMLFormElement | null>;
  accessories?: NonNullable<GetKitPageAccessoriesQueryResult>["accessories"];
  pending?: boolean;
  response?: ProductAccessoriesActionState;
};
